import React, {useState} from "react";
import {useSelector} from "react-redux";
import SearchTable from "../../../primer/Search-Table";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {getOptionsByData} from "../../../../_helpers/commonFunctions";
import {useTranslation} from "../../../../hooks/useTranslation";

const SearchSupplier = () => {
    const {t} = useTranslation();
    const tags = useSelector((state) => state.SUPPLIERS_DATA.suppliersSettings.tags);
    const categories = useSelector((state) => state.SUPPLIERS_DATA.suppliersSettings.categories);
    const supplierCategories = getObjectFromArrayOfObjects(categories, 'active', 'isActive');
    const supplierCategoriesOption = [{value: "", label: t("General.empty")}, ...getOptionsByData(supplierCategories, '_id', 'category')];

    const tagOptions = (tags || []).map((o) => ({value: o, label: o}));

    const searchSupplierFilters = {
        filters: [
            {
                name: "name",
                label: t("General.supplierNameVAT"),
                type: "input",
            },
            {
                name: "manualCode",
                label: t("General.manualCode"),
                type: "input",
            },
            {
                name: "category",
                label: t("General.categoryName"),
                type: "multiselect",
                options: supplierCategoriesOption
            },
            {
                name: "systemCode",
                label: t("General.systemCode"),
                type: "input",
            },
            {
                name: "tags",
                label: "Ετικέτες",
                type: "multiselect",
                options: tagOptions,
            },
            {
                name: "isActive",
                label: t("General.showInactiveSuppliers"),
                type: "checkbox",
            },
        ],
    }

    const scColumns = [
        {
            name: t("General.systemCode"),
            field: "systemCode",
            width: "10%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.manualCode"),
            field: "manualCode",
            width: "10%",
            hiddenColumn: true,
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.supplierName"),
            field: "name",
            editable:false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.category"),
            field: "categoryName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.vatNumber"),
            field: "vatNumber",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.contactName"),
            field: "contactName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.phone"),
            field: "phone",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
    ]

    const [tableColumns, setTableColumns] = useState(scColumns.slice());

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <div>
            <SearchTable
                tableName="Supplier Search"
                key={"Supplier Search"}
                hideYearFilter={true}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                allowPrintResults={true}
                dataEndpoint={"/supplier/master-supplier-search"}
                exportFileName={"Προμηθευτές"}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                data={[]}
                filtersConfig={searchSupplierFilters}
            />
        </div>
    )
}

export default SearchSupplier;
